var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCautionAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Settings&amp;Information/WarningAlert/Primary/32 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile:-SYNC-+-Maps-Wires",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile__Maps-NA-SYNC-4/4a",
    transform: "translate(-41.000000, -1094.000000)",
    fill: "#BA4E00"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maps",
    transform: "translate(24.000000, 1004.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MAPS",
    transform: "translate(0.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings&Information/WarningAlert/Primary/32-Copy",
    transform: "translate(16.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,16.7948847 C11.2879686,16.7948847 10.7779669,17.2616858 10.7779669,17.952312 C10.7779669,18.6441351 11.2879686,19.1252992 12,19.1252992 C12.7107995,19.1252992 13.2220331,18.6441351 13.2220331,17.952312 C13.2220331,17.2616858 12.7107995,16.7948847 12,16.7948847 L12,16.7948847 Z M12.5260163,15.5632481 C12.6652196,14.1197556 12.9276118,10.1663097 12.9276118,9.04000252 L12.9276118,8.43794885 L11.1019535,8.43794885 L11.1019535,9.04000252 C11.1019535,10.1663097 11.3655776,14.1197556 11.5047809,15.5632481 L12.5260163,15.5632481 Z M12,2.5 C11.5614478,2.5 11.1561566,2.72861283 10.9393442,3.0984629 L1.16061561,19.7237621 C0.945035168,20.0912183 0.946267056,20.5424594 1.16554316,20.9087187 C1.38481926,21.274978 1.78641482,21.5 2.22250325,21.5 L21.7774968,21.5 C22.2135852,21.5 22.6151807,21.274978 22.8344568,20.9087187 C23.0537329,20.5424594 23.0549648,20.0912183 22.8393844,19.7237621 L13.0606558,3.0984629 C12.8438434,2.72861283 12.4385522,2.5 12,2.5 L12,2.5 Z M12,3.68735038 L21.7774968,20.3126496 L2.22250325,20.3126496 L12,3.68735038 L12,3.68735038 Z",
    id: "Warning"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionAlert);
export default __webpack_public_path__ + "static/media/caution-alert.75ce3f7b9d7b33fe8921a5793dcb2a5c.svg";
export { ForwardRef as ReactComponent };